// shared-actions.ts
import * as Shared from './shared.actions';
import * as Reference from './reference.actions';

// Combina todas las acciones bajo un solo alias
export const SharedActions = {
  ...Shared,
  ...Reference
};
